const venueTemplate = require('../../templates').venueTemplate;
const roomTemplate = require('../../templates').roomTemplate;

const venueData = Object.assign({}, venueTemplate, {
	id: 'nordborg-resort',
	name: 'Nordborg Resort',
	website: 'https://www.centerparcs.dk/dk-da/danmark/fp_NO_naturresort-park-nordborg-resort',
	locations: [{
		id: 'nordborg',
		cityId: 'nordborg',
		opened: '20250620',
		closed: null,
		address: 'Resortet 1, 6430 Nordborg',
		coordinates: {lat: '55.0448', lng: '9.81519'},
	}],
	rooms: [
		Object.assign({}, roomTemplate, {
			// https://www.sonderborgnyt.dk/nordborg-resort-aabner-escape-room-med-nordisk-mytologi-for-feriegaester-og-lokale/
			id: 'ragnarok',
			name: {da: 'Ragnarok Escape Room', en: 'Ragnarok Escape Room'},
			minutes: 60,
			minPlayers: 1,
			maxPlayers: 7,
			minimumAge: 6,
			locations: [{
				locationId: 'nordborg',
				opened: '20251216',
				closed: null,
				rooms: 1
			}]
		})
	]
});


export {venueData};